var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _g, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 254,
    viewBox: "0 0 254 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 127,
    r: 125.5,
    fill: "white",
    fillOpacity: 0.4,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M229 179.998C229 181.103 184.676 182 130 182C99.1497 182 71.5953 181.715 53.4386 181.267C49.2568 181.164 45.5736 181.053 42.4639 180.935C40.4158 180.858 38.6141 180.776 37.0859 180.692C33.1496 180.477 31 180.243 31 180C31 179.69 34.4875 179.396 40.7174 179.134C43.2678 179.024 46.277 178.924 49.6948 178.829C67.6758 178.326 96.9463 178 130 178C159.075 178 185.222 178.253 203.334 178.657C219.282 179.009 229 179.481 229 179.998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M185.408 72H37.5917C35.6081 72 34 73.6008 34 75.5754V162.425C34 164.399 35.6081 166 37.5917 166H185.408C187.392 166 189 164.399 189 162.425V75.5754C189 73.6008 187.392 72 185.408 72Z",
    fill: "#040C2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181 76H40V161H181V76Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131 166H90V175H131V166Z",
    fill: "#040C2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7216 174H143.277C143.469 174 143.653 174.089 143.788 174.248C143.924 174.407 144 174.623 144 174.848V180H79V174.85C78.9998 174.738 79.0183 174.628 79.0545 174.525C79.0906 174.422 79.1437 174.328 79.2107 174.249C79.2777 174.171 79.3573 174.108 79.445 174.065C79.5327 174.022 79.6266 174 79.7216 174Z",
    fill: "#040C2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M131 166H90V174H131V166Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 164C110.328 164 111 163.552 111 163C111 162.448 110.328 162 109.5 162C108.672 162 108 162.448 108 163C108 163.552 108.672 164 109.5 164Z",
    fill: "url(#paint0_radial_630_1717)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97 149H90V139H97V140.033H91.4602V143.255H96.6646V144.284H91.4602V147.964H97V149Z",
    fill: "#420083"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9902 144.842V149H99V139H101.335C102.38 139 103.152 139.235 103.651 139.705C104.15 140.174 104.4 140.881 104.4 141.825C104.4 143.147 103.829 144.041 102.687 144.508L105 148.998H103.829L101.766 144.84L99.9902 144.842ZM99.9902 143.843H101.348C102.047 143.843 102.561 143.68 102.888 143.354C103.215 143.028 103.378 142.539 103.377 141.887C103.377 141.226 103.212 140.749 102.881 140.457C102.549 140.165 102.016 140.019 101.281 140.019H99.9931L99.9902 143.843Z",
    fill: "#420083"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.156 144.842V149H107V139H109.724C110.943 139 111.844 139.235 112.426 139.705C113.009 140.174 113.3 140.881 113.3 141.825C113.3 143.147 112.634 144.041 111.301 144.508L114 148.998H112.634L110.227 144.84L108.156 144.842ZM108.156 143.843H109.739C110.555 143.843 111.154 143.68 111.536 143.354C111.918 143.028 112.108 142.539 112.107 141.887C112.107 141.226 111.914 140.749 111.527 140.457C111.141 140.165 110.519 140.019 109.662 140.019H108.156V143.843Z",
    fill: "#420083"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122 143.996C122 145.551 121.692 146.774 121.076 147.664C120.46 148.555 119.604 149 118.508 149C117.387 149 116.522 148.563 115.913 147.688C115.304 146.813 115 145.578 115 143.982C115 142.401 115.305 141.175 115.916 140.303C116.527 139.432 117.394 138.998 118.518 139C119.611 139 120.465 139.443 121.079 140.329C121.693 141.215 122 142.437 122 143.996ZM115.937 143.996C115.937 145.312 116.156 146.309 116.595 146.989C117.034 147.669 117.671 148.009 118.508 148.009C119.351 148.009 119.987 147.671 120.416 146.993C120.845 146.315 121.06 145.316 121.061 143.996C121.061 142.689 120.847 141.697 120.419 141.021C119.99 140.345 119.356 140.008 118.516 140.008C117.673 140.008 117.032 140.348 116.593 141.028C116.154 141.708 115.935 142.697 115.937 143.996Z",
    fill: "#420083"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.156 144.842V149H124V139H126.724C127.943 139 128.844 139.235 129.426 139.705C130.009 140.174 130.3 140.881 130.3 141.825C130.3 143.147 129.634 144.041 128.301 144.508L131 148.998H129.634L127.227 144.84L125.156 144.842ZM125.156 143.843H126.739C127.555 143.843 128.154 143.68 128.536 143.354C128.918 143.028 129.108 142.539 129.107 141.887C129.107 141.226 128.914 140.749 128.527 140.457C128.141 140.165 127.519 140.019 126.662 140.019H125.159L125.156 143.843Z",
    fill: "#420083"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111 88L84 131H138L111 88Z",
    fill: "#913BEF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M112 94L90 128H134L112 94Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M114 105L113.355 115.673H108.645L108 105H114ZM113.727 117.226V122H108.273V117.226H113.727Z",
    fill: "#420083"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.425 136H155.575C155.258 136 155 136.381 155 136.851V179.149C155 179.619 155.258 180 155.575 180H157.425C157.742 180 158 179.619 158 179.149V136.851C158 136.381 157.742 136 157.425 136Z",
    fill: "#913BEF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.425 136H211.575C211.258 136 211 136.381 211 136.851V179.149C211 179.619 211.258 180 211.575 180H213.425C213.742 180 214 179.619 214 179.149V136.851C214 136.381 213.742 136 213.425 136Z",
    fill: "#913BEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.743 139.507H154.289V167.979H158.743V139.507Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.81 139.507H210.356V167.979H214.81V139.507Z",
    fill: "black"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M216.238 140H153.762C153.341 140 153 140.384 153 140.858V152.142C153 152.616 153.341 153 153.762 153H216.238C216.659 153 217 152.616 217 152.142V140.858C217 140.384 216.659 140 216.238 140Z",
    fill: "#913BEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M216.238 155H153.762C153.341 155 153 155.355 153 155.792V166.208C153 166.645 153.341 167 153.762 167H216.238C216.659 167 217 166.645 217 166.208V155.792C217 155.355 216.659 155 216.238 155Z",
    fill: "#913BEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158 140L153 149V144.003L155.224 140H158Z",
    fill: "#420083"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M154.949 155H158L153 162V157.728L154.949 155Z",
    fill: "#420083"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170 140L161.341 153H158L166.659 140H170Z",
    fill: "#420083"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M166.659 155H170L161.341 167H158L166.659 155Z",
    fill: "#420083"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M181 140L172.341 153H169L177.659 140H181Z",
    fill: "#420083"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M176.381 155H180L170.62 167H167L176.381 155Z",
    fill: "#420083"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M193 140L182.898 153H179L189.102 140H193Z",
    fill: "#420083"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M188.823 155H193L182.177 167H178L188.823 155Z",
    fill: "#420083"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204 140L195.341 153H192L200.659 140H204Z",
    fill: "#420083"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.658 155H203L194.341 167H191L199.658 155Z",
    fill: "#420083"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M214 140L206.062 153H203L210.937 140H214Z",
    fill: "#420083"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M210.38 155H214L204.62 167H201L210.38 155Z",
    fill: "#420083"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M217 147V152.574L216.716 153H213L217 147Z",
    fill: "#420083"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217 161V165.843L216.228 167H213L217 161Z",
    fill: "#420083"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M208 178H190L190.329 176.994L191.12 174.569L192.045 171.737L193.018 168.755L193.943 165.922L194.917 162.94L195.841 160.107L197.078 156.319C197.202 155.938 197.456 155.604 197.803 155.366C198.149 155.128 198.569 155 199 155C199.431 155 199.851 155.128 200.197 155.366C200.544 155.604 200.798 155.938 200.922 156.319L202.159 160.107L203.083 162.94L204.057 165.922L204.982 168.755L205.955 171.737L206.88 174.569L207.671 176.994L208 178Z",
    fill: "#F6471E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M209.856 178H189.144C189.064 178 189 178.063 189 178.141V179.859C189 179.937 189.064 180 189.144 180H209.856C209.936 180 210 179.937 210 179.859V178.141C210 178.063 209.936 178 209.856 178Z",
    fill: "#F6471E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M203 163H194L195.019 160H201.981L203 163Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M205 170H193L193.927 167H204.073L205 170Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M207 175H191L191.939 173H206.061L207 175Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_630_1717",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.432 162.701) scale(1.51064 0.997364)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImage);
export default __webpack_public_path__ + "static/media/error-image.679705d63c3ee5f42c8b7422967a59dd.svg";
export { ForwardRef as ReactComponent };